module.exports = __webpack_public_path__ + "img/activemarketplace.93a73d0b.svg";